import { createStore, compose, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import createOidcMiddleware, { createUserManager, loadUser } from "redux-oidc";
import rootReducer from "../reducers/index";
import rootSaga from "../saga";
import userManager from "../oidc/userManager";

export default initialState => {
  //const oidcMiddleware = createOidcMiddleware(userManager);

  const sagaMiddleware = createSagaMiddleware();

  const windowIfDefined = typeof window === "undefined" ? null : window;
  const devToolsExtension =
    windowIfDefined && windowIfDefined.devToolsExtension; // If devTools is installed, connect to it

  const createStoreWithMiddleware = compose(
    applyMiddleware(sagaMiddleware),
    devToolsExtension ? devToolsExtension() : f => f
  )(createStore);

  const store = createStoreWithMiddleware(rootReducer, initialState);
  loadUser(store, userManager);

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept("../reducers/index", () => {
      store.replaceReducer(require("../reducers/index"));
    });
  }

  return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js